export const PN = "pn";
export const EMPLOYEE = "employee";
export const NETWORKER = "networker";